import script from "./UserModal.vue?vue&type=script&setup=true&lang=js"
export * from "./UserModal.vue?vue&type=script&setup=true&lang=js"

import "./UserModal.vue?vue&type=style&index=0&id=66de148e&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-66de148e"]])

export default __exports__